import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import type { VisitorPass, CreateVisitorPassRequest } from '@condo/contracts';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useCreateVisitorPass } from '@/features/visitas/api';
import { VisitorPassForm } from '@/features/visitas/visitor-pass-form';
import { QrDisplay } from '@/features/visitas/qr-display';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Button } from '@/components/ui/button';

export function CrearVisitaRoute() {
  const { condoId } = useCondoContext();
  const mutation = useCreateVisitorPass(condoId);
  const [createdPass, setCreatedPass] = useState<VisitorPass | null>(null);

  async function handleSubmit(values: CreateVisitorPassRequest) {
    try {
      const pass = await mutation.mutateAsync(values);
      setCreatedPass(pass);
      toast.success('Pase creado', {
        description: `Pase para ${pass.visitorNombre} generado exitosamente.`,
      });
    } catch {
      toast.error('No se pudo crear el pase de visita');
    }
  }

  return (
    <PageContainer width="form">
      <Button variant="ghost" asChild size="sm" className="mb-4">
        <Link to={`/app/condominios/${condoId}/visitas`}>
          <ArrowLeft className="h-4 w-4" />
          Volver
        </Link>
      </Button>

      {createdPass ? (
        <>
          <PageHeader
            eyebrow="Pase generado"
            title="Pase de visita listo"
            subtitle="Comparte el codigo QR o el enlace con tu visitante para que pueda ingresar."
          />
          <QrDisplay pass={createdPass} className="mx-auto max-w-sm" />
          <div className="mt-6 flex justify-center">
            <Button variant="outline" onClick={() => setCreatedPass(null)}>
              Crear otro pase
            </Button>
          </div>
        </>
      ) : (
        <>
          <PageHeader
            eyebrow="Nuevo pase"
            title="Crear pase de visita"
            subtitle="Ingresa los datos del visitante para generar un codigo QR de acceso."
            ruleSpacing="mb-8"
          />
          <VisitorPassForm
            onSubmit={handleSubmit}
            isSubmitting={mutation.isPending}
            onCancel={undefined}
          />
        </>
      )}
    </PageContainer>
  );
}
